/** Fixed bottom toast · sits above the sticky header and stays on screen. */
export const newVersionBannerLayout = {
  shell:
    "pointer-events-none fixed inset-x-0 bottom-0 z-[70] px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2",
  panel:
    "pointer-events-auto mx-auto flex w-full max-w-5xl flex-wrap items-center justify-between gap-3 rounded-2xl bg-[#0071BC] px-4 py-3 text-white shadow-[0_-8px_32px_-12px_rgba(15,23,42,0.45)]",
  message: "min-w-0 flex-1 text-sm font-medium leading-snug",
} as const;
